(function () {
  'use strict';

  if (window.__ubSizeRequiredLoaded) return;
  window.__ubSizeRequiredLoaded = true;

  const SIZE_OPTION_NAME = 'size';

  function getSizeRadios(picker) {
    return Array.from(
      picker.querySelectorAll(
        'input[type="radio"][data-option-name]'
      )
    ).filter(
      (radio) =>
        radio.dataset.optionName
          ?.trim()
          .toLowerCase() === SIZE_OPTION_NAME
    );
  }

  function getProductForms(picker) {
    const section =
      picker.closest('.shopify-section') || document;

    const productId = picker.dataset.productId;

    return Array.from(
      section.querySelectorAll(
        'product-form-component'
      )
    ).filter(
      (form) =>
        !productId ||
        !form.dataset.productId ||
        form.dataset.productId === productId
    );
  }

  function lockProductForms(picker) {
    const forms = getProductForms(picker);

    return forms.map((form) => {
      const variantInput =
        form.querySelector('input[name="id"]');

      const buttons = Array.from(
        form.querySelectorAll(
          '[ref="addToCartButton"], button[name="add"]'
        )
      );

      const acceleratedCheckoutContainers =
        Array.from(
          form.querySelectorAll(
            '[ref="acceleratedCheckoutButtonContainer"]'
          )
        );

      const state = {
        form,
        variantInput,
        originalVariantId:
          variantInput?.value || '',
        buttons: buttons.map((button) => ({
          button,
          originallyDisabled: button.disabled,
        })),
        acceleratedCheckoutContainers:
          acceleratedCheckoutContainers.map(
            (container) => ({
              container,
              originallyHidden: container.hidden,
            })
          ),
      };

      if (variantInput) {
        variantInput.value = '';
      }

      buttons.forEach((button) => {
        /*
         * Use the native disabled property only.
         * Do not add aria-disabled because Horizon does
         * not remove it when enabling the button.
         */
        button.disabled = true;
        button.removeAttribute('aria-disabled');
      });

      acceleratedCheckoutContainers.forEach(
        (container) => {
          container.hidden = true;
        }
      );

      return state;
    });
  }

  function restoreOriginalFormState(savedStates) {
    savedStates.forEach((state) => {
      if (state.variantInput) {
        state.variantInput.value =
          state.originalVariantId;
      }

      state.buttons.forEach(
        ({ button, originallyDisabled }) => {
          button.disabled = originallyDisabled;
          button.removeAttribute('aria-disabled');
        }
      );

      state.acceleratedCheckoutContainers.forEach(
        ({ container, originallyHidden }) => {
          container.hidden = originallyHidden;
        }
      );
    });
  }

  function removeStaleDisabledAppearance(picker) {
    getProductForms(picker).forEach((form) => {
      form
        .querySelectorAll(
          '[ref="addToCartButton"], button[name="add"]'
        )
        .forEach((button) => {
          button.removeAttribute('aria-disabled');
        });
    });
  }

  function initialise(root = document) {
    const picker = root.querySelector(
      'variant-picker[data-template-product-match="true"]'
    );

    if (!picker) return;

    if (
      picker.dataset.ubSizeRequiredInitialised ===
      'true'
    ) {
      return;
    }

    const url = new URL(window.location.href);

    /*
     * Keep a deliberately selected variant when the
     * product URL contains ?variant=.
     */
    if (url.searchParams.has('variant')) {
      return;
    }

    const sizeRadios = getSizeRadios(picker);

    if (sizeRadios.length <= 1) return;

    const fieldset =
      sizeRadios[0].closest('fieldset');

    const legend =
      fieldset?.querySelector('legend');

    if (!fieldset || !legend) return;

    picker.dataset.ubSizeRequiredInitialised =
      'true';

    picker.classList.add(
      'ub-size-required-active'
    );

    const initiallyCheckedRadio =
      sizeRadios.find((radio) => radio.checked) ||
      null;

    const savedFormStates =
      lockProductForms(picker);

    if (
      !legend.querySelector('.ub-size-prompt')
    ) {
      const prompt =
        document.createElement('span');

      prompt.className = 'ub-size-prompt';
      prompt.textContent =
        ' – Please select a size';

      legend.appendChild(prompt);
    }

    sizeRadios.forEach((radio) => {
      radio.addEventListener('click', () => {
        if (
          !picker.classList.contains(
            'ub-size-required-active'
          )
        ) {
          return;
        }

        picker.classList.remove(
          'ub-size-required-active'
        );

        legend
          .querySelector('.ub-size-prompt')
          ?.remove();

        /*
         * Clicking the size that Shopify selected
         * internally may not trigger a change event.
         * Restore its original variant manually.
         */
        if (radio === initiallyCheckedRadio) {
          restoreOriginalFormState(
            savedFormStates
          );
          return;
        }

        /*
         * For another size, Horizon performs its normal
         * variant update. Remove any stale aria-disabled
         * attribute while Horizon enables the button.
         */
        removeStaleDisabledAppearance(picker);

        requestAnimationFrame(() => {
          removeStaleDisabledAppearance(picker);
        });

        setTimeout(() => {
          removeStaleDisabledAppearance(picker);
        }, 300);
      });
    });
  }

  function boot() {
    customElements
      .whenDefined('variant-picker')
      .then(() => {
        requestAnimationFrame(() => {
          initialise(document);
        });
      })
      .catch((error) => {
        console.error(
          'Ummah Balance size selector failed:',
          error
        );
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      boot,
      { once: true }
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialise(event.target);
    }
  );
})();